import { combineEpics } from "redux-observable";
import { EXP_QUERY_STRINGS } from "@ane/core/lib/constants/QueryString.constants";
import { produceUserContextRouteQueryStringEpics } from "@ane/core/lib/services/syncUrlAndStore/ProduceUserContextRouteQueryStringEpics";
import TenantActions from "./TenantActions.js";
import TenantPageConstants from "./TenantConstants.js";
import { ROUTES } from "@ane/exp-data/lib/routes/Routes.constants";
import { matchesRootPathname } from "@ane/exp-data/lib/routes/Route.utils";
const tenantUserContextParams = {
  // TODO: this should really be a paramType => "enum", and isMultiValue = false, but that is not implemented yet
  tid: { paramType: "string" },
  workspaceId: { paramType: "string" },
  groupIdClassic: { paramType: "string" },
  groupIdAzure: { paramType: "string" },
  subscriptionId: { paramType: "string" },
  experience: { paramType: "string" },
  selectedWorkspaceId: { paramType: "string" },
  wpsTenantId: { paramType: "string" },
  wpsSubscriptionId: { paramType: "string" },
  wpsWorkspaceId: { paramType: "string" },
  wpsGroupId: { paramType: "string" }
};
const produceTenantRouteQueryStringSyncEpics = (history) => {
  const setUserContextFromRouteQueryString = produceUserContextRouteQueryStringEpics(
    tenantUserContextParams,
    TenantActions.setUserContext,
    TenantPageConstants.SET_PARTIAL_USER_CONTEXT,
    TenantPageConstants.SET_USER_CONTEXT,
    // todo: we need to pass in a func that allows us to "find" the user context in the store
    // to be more of a plugin, this method should not "know" this, but rather be passed in
    // this would allow this to be used in the context of an app-module, and its hosting app
    (store) => store.tenantReducer.userContext,
    history,
    //TODO: Need to make sure all the other workspace-selector path are included here
    (pathname) => matchesRootPathname(pathname, `${ROUTES.tenant.match.path}`) || matchesRootPathname(pathname, `${ROUTES.workspaceSelector.match.path}`) || matchesRootPathname(pathname, `${ROUTES.onboarding.match.path}`),
    EXP_QUERY_STRINGS
  );
  return combineEpics(...Object.values(setUserContextFromRouteQueryString));
};
export {
  produceTenantRouteQueryStringSyncEpics,
  tenantUserContextParams
};
//# sourceMappingURL=TenantUserContext.js.map
